import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    minWidth: '375px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '65vh',
    padding: '140px 20px 64px 20px',
    boxSizing: 'border-box',
    gap: '24px',
  },

  title: {
    fontFamily: 'MontserratBold',
    fontWeight: 700,
    fontSize: '48px',
    lineHeight: '54px',
    textAlign: 'center',
    marginBottom: '16px',
    color: theme.palette.text.nonary,
  },

  message: {
    marginTop: 20,
    marginBottom: 20,
    fontFamily: 'Montserrat',
    fontWeight: '400',
    fontStyle: 'normal',
    fontSize: '20px',
    lineHeight: '30px',
    textAlign: 'left',
    color: theme.palette.text.quaternary,
  },
}));
export default useStyles;
